import { Component } from '@cms-max/medicare-api-sdk/dist/api'
import { Card as SettingCard } from 'components/Card/Card'
import { CardStack, CardStackItem } from 'components/CardStack/CardStack'
import { useTranslation } from 'react-i18next'

type EasyPayEnrolledCardProps = {
  status: 'active' | 'pending'
  disableEdit?: boolean
}
export function EasyPayEnrolledCard ({ status, disableEdit }: EasyPayEnrolledCardProps) {
  const { t } = useTranslation('easyPaySummary')

  return (
    <CardStack>
      <CardStackItem>
        <SettingCard
          title={t('easyPayStatus.enrollmentStatus')}
          buttonText={t('easyPayStatus.buttons.stop')}
          buttonCallbackOrHref={`/premiums/easy-pay/stop`}
          displayValue={t(`easyPayStatus.statuses.${status}`)}
          disableEdit={disableEdit}
          buttonSiteActivityProps={{
            core: {
              component: Component.EasyPay,
              elementId: 'premiums_easypaylanding_easypaystop_click',
              coreClickData: {
                linkText: t('easyPayStatus.buttons.stop'),
                linkUrl: '/premiums/easy-pay/stop'
              }
            }
          }}
          headingLevel='3'
        />
      </CardStackItem>
    </CardStack>
  )
}
